/* 
  Number 'loadedCount' is accurate. 'InaccurateAllCount' uses cardinality aggregation which is faster but approximate. 
  'LoadedCount' uses terms aggregation which is slower but accurate.
  We cannot improve the accuracy of cardinality aggregation beyond what we have right now. 
  We are already using the max config value allowed by ES 
*/

const itemsCountManager = ({ searchCount, loadedCount = 0, inaccurateAllCount }) => {
  switch (true) {
    case searchCount >= inaccurateAllCount:
    case loadedCount > inaccurateAllCount:
      return {
        searchCount,
        loadedCount,
        inaccurateAllCount: loadedCount
      }
    default:
      return {
        searchCount,
        loadedCount,
        inaccurateAllCount
      }
  }
}

export default itemsCountManager
